import { type FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ConfirmDialog } from './ConfirmDialog';
import { LabeledTextarea } from './LabeledTextarea';

interface BanMemberDialogProps {
  isOpen: boolean;
  onConfirm: (reason?: string) => void;
  onCancel: () => void;
  memberName: string;
  isLoading?: boolean;
}

export const BanMemberDialog: FC<BanMemberDialogProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  memberName,
  isLoading = false,
}) => {
  const { t } = useTranslation();
  const [reason, setReason] = useState('');

  const handleConfirm = () => {
    onConfirm(reason.trim() || undefined);
  };

  return (
    <ConfirmDialog
      isOpen={isOpen}
      title={t('community.action_menu.ban_member_confirm_title', { memberName })}
      description={t('community.action_menu.ban_member_confirm_description')}
      confirmLabel={t('community.action_menu.ban_member_confirm_button')}
      onConfirm={handleConfirm}
      onCancel={onCancel}
      isDestructive
      isLoading={isLoading}
      body={
        <LabeledTextarea
          id="ban-member-reason"
          label={t('community.action_menu.ban_member_reason_placeholder')}
          hideLabel
          placeholder={t('community.action_menu.ban_member_reason_placeholder')}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          disabled={isLoading}
          containerClassName="mt-4"
        />
      }
    />
  );
};
